import { render, staticRenderFns } from "./collection.vue?vue&type=template&id=6c72b2a6&scoped=true"
import script from "./collection.vue?vue&type=script&lang=js"
export * from "./collection.vue?vue&type=script&lang=js"
import style0 from "./collection.vue?vue&type=style&index=0&id=6c72b2a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c72b2a6",
  null
  
)

export default component.exports